import React from 'react'

const IcArrowDownGray = (props) => {
    return (
        <svg {...props} width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#777777" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default IcArrowDownGray
